import { render, staticRenderFns } from "./ngo-admin.vue?vue&type=template&id=f584c1d6&scoped=true&"
import script from "./ngo-admin.vue?vue&type=script&lang=js&"
export * from "./ngo-admin.vue?vue&type=script&lang=js&"
import style0 from "./ngo-admin.vue?vue&type=style&index=0&id=f584c1d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f584c1d6",
  null
  
)

export default component.exports